export default __webpack_public_path__ + "static/media/GuyAnimation18.d4efa21b.svg";